/**
 * @import { Port } from '@/features/itinerary-map/types/port'
 */

import { zIndex } from '@/features/itinerary-map/utils/layer';
import { AdvancedMarker, useAdvancedMarkerRef } from '@vis.gl/react-google-maps';
import { useEffect } from 'react';
import { PortSymbol } from './port-symbol/port-symbol';

/**
 * @param {object} props
 * @param {Port} props.port
 * @param {boolean} props.isCurrent
 * @param {boolean} props.isStart
 * @param {boolean} [props.isOvernight]
 * @param {string} props.ariaLabel
 * @param {(marker: google.maps.marker.AdvancedMarkerElement) => void} props.onClick
 * @returns {React.JSX.Element | null}
 */
export function PortMarker({ port, isCurrent, isStart, isOvernight, ariaLabel, onClick }) {
  const [markerRef, marker] = useAdvancedMarkerRef();
  const position = port.position ? { lat: port.position[1], lng: port.position[0] } : null;

  /** @this {google.maps.marker.AdvancedMarkerElement} */
  function handleOnClick() {
    onClick(this);
  }

  const getZIndex = () => {
    if (isCurrent) {
      return zIndex.portCurrent;
    }
    if (isStart) {
      return zIndex.portStart;
    }
    if (isOvernight) {
      return zIndex.portOvernight;
    }
    return zIndex.port;
  };

  useEffect(() => {
    if (marker) {
      marker.ariaLabel = ariaLabel;
    }
  }, [marker, ariaLabel]);

  return (
    position && (
      <AdvancedMarker
        style={{ lineHeight: 0 }}
        ref={markerRef}
        zIndex={getZIndex()}
        position={position}
        onClick={handleOnClick}
      >
        <PortSymbol isStart={isStart} isCurrent={isCurrent} isOvernight={isOvernight} />
      </AdvancedMarker>
    )
  );
}
